import gtm from "./scripts/gtm";
import wpcf7Structure from "./scripts/wpcf7-structure";
import { extendJquery,validateEmail } from "./scripts/utils";
import skipLinkFocusFix from "./scripts/skip-link-focus-fix";
import  popup from "./scripts/popup";
import navigation from "./scripts/navigation";
import setupAnimations from "./scripts/animations";
import ready from "./scripts/ready";

ready(()=>{
    setupAnimations();
    popup();
})

skipLinkFocusFix();
extendJquery();
wpcf7Structure();
gtm.listen();
navigation();



(function($){
    
    ready(()=>{
         // parallax des bannières
         $('.with-parallax').each(function(){
            $(this).children('img').parallax($(this),4,0);
        });
        // parallax de la bannière générale
        if($('.banner-parallax').length){
            $('.banner-parallax img').parallax($('.banner'),4,0);
        }
        $( window ).on( "resize", function() {
            $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
        } );
        $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
    });


     /* inscription a l'infolettre */
     $('.infolettre, .newsletter-form').submit(function(e){
        e.preventDefault();
        var messageLogWrapper = $(this).find('.message-form');
        var messageLog = $(this).find('.cdm-message-ouput');
        if(!validateEmail($(this).find('input[name="email"]').val())){
            messageLog.text(siteData.traduction.emailError);
            messageLogWrapper.removeClass('success').addClass('invalid');
        }else{
            var data = {
                email: $(this).find('input[name="email"]').val(),
                lang: siteData.lang
            }

            if($(this).hasClass('full-name')){
                if($(this).find('input[name="firstname"]').val() == "" || $(this).find('input[name="lastname"]').val() == ""){
                    messageLog.text(siteData.traduction.titleError);
                    messageLogWrapper.removeClass('success').addClass('invalid');
                    return;
                }
                data.fname = $(this).find('input[name="firstname"]').val();
                data.lname = $(this).find('input[name="lastname"]').val();
            }

            wp.apiFetch({
                path: "codems/newsletter/subscription",
                method: 'POST',
                data: data
            }).then( res => {
                if(res.success){				
                    messageLog.html(res.message);
                    messageLogWrapper.removeClass('invalid').addClass('success');
                    
                }else{
                    messageLog.html(res.message);
                    messageLog.removeClass('success').addClass('error');
                }
            })
            
            return false;
        }
    });

    if($(window).width() <= 1024 && $('.blog-wrapper').length){
        $('.blog-wrapper .sidebar .sidebar-title').click(function(){
            $(this).siblings('ul').slideToggle();
        });
    }

    if($(document).scrollTop() > $('.site-header').height()){
         $('body').addClass('full-header');
    }   
    else{
        $('body').removeClass('full-header');
    }

    //menu sticky on scroll up
	var previousScrollTop = 0;

    $(document).scroll(function() {
		var y = $(this).scrollTop();
        var heightToSticky = 100;

		if(!$('body').hasClass('menu-open') && !$('body').hasClass('about-menu-open')){

            if(y > heightToSticky){
                 $('body').addClass('full-header');
                 $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
                // retire la nav au scroll down et la fait apparaitre on scroll up
                if(y > previousScrollTop){
                    $('body').addClass('hide-nav'); 
                }else{
                    $('body').removeClass('hide-nav');
                }
            }   
            else{
                $('body').removeClass('full-header');
                $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
            }
		}		
		previousScrollTop = y;

	});

    // le bloc faq de yoast
    $('.schema-faq-question').click(function(){
        $(this).parent().toggleClass('open').find('.schema-faq-answer').slideToggle();
    });

    if($('.wpcf7-form').length || $('.infolettre').length || $('.my-account-validation').length){

        $('.fields input, .fields textarea').each(function(){
            if($(this).val()){
                $(this).parent().parent('.fields').addClass('is-active');
            }
        });

        $('.fields input, .fields textarea').on('focusout', function(){
            if(!$(this).val()){
                $(this).parent().parent('.fields').removeClass('is-active');
            }
        });
        $('.fields input, .fields textarea').on('focus', function(){
            $(this).parent().parent('.fields').addClass('is-active');
        });
    }

})(jQuery);